import { Variable } from '@microservices/wiskey-react-components'

import { TIME_LINE_MODE } from '@constants'
import { AutocompleteOption, ObjectFieldDTO, TimelineActionMeta } from '@types'

type Props = {
  watchMode: AutocompleteOption<TIME_LINE_MODE> | null
  objectXSelectedColumnsObjectFields: ObjectFieldDTO[]
  objectXSelectedObjectFields: ObjectFieldDTO[]
  objectYSelectedObjectFields: ObjectFieldDTO[]
}

export const getObjectXActionDialogMeta = (props: Props): TimelineActionMeta => {
  const {
    watchMode,
    objectXSelectedColumnsObjectFields,
    objectYSelectedObjectFields,
    objectXSelectedObjectFields,
  } = props

  return {
    scriptAdditionalInfo: {
      columnFields:
        watchMode?.id === TIME_LINE_MODE.DATE_TIME
          ? [
              { name: 'startDate', type: 'string' },
              { name: 'endDate', type: 'string' },
            ]
          : !objectXSelectedColumnsObjectFields?.length
          ? 'any'
          : objectXSelectedColumnsObjectFields.map(field => {
              return {
                name: field.name,
                type: field.valueType,
              }
            }),
      objectXItemFields: !objectXSelectedObjectFields?.length
        ? 'any'
        : objectXSelectedObjectFields.map(field => {
            return {
              name: field.name,
              type: field.valueType,
            }
          }),
      rowData: [
        { name: 'startDate', type: 'string' },
        { name: 'endDate', type: 'string' },
        { name: 'id', type: 'string' },
        { name: 'groupId', type: 'string' },
        {
          name: 'yElement',
          type: !objectYSelectedObjectFields?.length
            ? 'any'
            : objectYSelectedObjectFields.map(field => {
                return {
                  name: field.name,
                  type: field.valueType,
                  description: field.desc,
                } as Variable
              }),
        },
      ],
    },
  }
}
